export enum BpmnTimerDurationTypes {
    Minutes = "m",
    Hours = "h",
    Days = "d",
    Weeks = "w",
    Months = "M"
}